import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import { ReactNode } from "react";
import { ItemStatusType } from "../../../types/Item.ts";

const IfItemStatus = ({
  id,
  acceptedStatus,
  children,
  fallback,
}: {
  id: string;
  acceptedStatus: ItemStatusType[];
  children: ReactNode;
  fallback: ReactNode;
}) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);

  if (isLoading || !acceptedStatus.includes(item.status)) return fallback;
  if (isError) return isError;
  return children;
};
export default IfItemStatus;
